import { Form, Modal } from "antd";
import React from "react";
import { CreateWaterConsumptionHouseholdDto } from "../../../../api";
import { WaterConsumptionHouseholdColumns } from "../form/columns";

interface WaterConsumptionHouseholdFormProps {
  visible: boolean;
  setVisible: Function;
  onCreateWaterConsumptionHousehold: (values: CreateWaterConsumptionHouseholdDto) => void;
}

export const WaterConsumptionHouseholdForm: React.FC<WaterConsumptionHouseholdFormProps> = ({ visible, setVisible, onCreateWaterConsumptionHousehold }) => {
  const [form] = Form.useForm<CreateWaterConsumptionHouseholdDto>();

  return (
    <Modal open={visible} onOk={form.submit} okText="Создать" cancelText="Отмена" onCancel={() => setVisible(false)}>
      <Form form={form} className="p-8" layout="vertical" onFinish={onCreateWaterConsumptionHousehold}>
        {WaterConsumptionHouseholdColumns().map(({ title, key, rules, inputNode, hideOnForm }, index) => (
          <>
            {!hideOnForm && <Form.Item label={title} name={key} rules={rules} key={index}>
              {inputNode}
            </Form.Item>}
          </>
        ))}
      </Form>
    </Modal>
  );
};
